import { FormGroup, Input } from "reactstrap";

import AppInput from "../../AppInput";
import RequiredTitle from "../../../elements/RequiredTitle";
import StrUtils from "../../../utils/StrUtils";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";

const InformationGroup = ({
  fieldValues,
  setFieldValues,
  disableAPIName,
  showModificationProtection,
  setShowError,
  handleSubmit,
}) => {
  const handleNameChange = (e) => {
    if (typeof setShowError === "function") setShowError(false);
    const name = e.target.value;

    let payload = { name };

    if (
      !disableAPIName &&
      (!fieldValues.protected || showModificationProtection)
    ) {
      payload.apiName = StrUtils.cleanAPIName(name);
    }

    setFieldValues((prev) => ({ ...prev, ...payload }));
  };

  const handleAPINameChange = (e) => {
    let apiName = StrUtils.cleanAPIName(e.target.value);

    setFieldValues((prev) => ({ ...prev, apiName: apiName }));
  };

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFieldValues((prev) => ({ ...prev, [name]: value }));
  };

  const onHandleSubmit = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <form onSubmit={handleSubmit ? onHandleSubmit : undefined}>
      <RequiredTitle size="lg" title="Field Name" />
      <AppInput
        placeholder="Name"
        required={true}
        value={fieldValues.name}
        onChange={handleNameChange}
        disabled={fieldValues.renameProtected && !showModificationProtection}
        autoFocus
        className="tw:mb-6"
      />

      <RequiredTitle size="lg" title="Field API Name" />
      <AppInput
        placeholder="API Name"
        required={true}
        value={fieldValues.apiName}
        onChange={handleAPINameChange}
        disabled={
          disableAPIName ||
          (fieldValues.protected && !showModificationProtection)
        }
        className="tw:mb-6"
      />

      <h4>Description</h4>
      <AppInput
        placeholder="Description"
        type="textarea"
        name="description"
        required={false}
        value={fieldValues.description}
        onChange={handleInputChange}
        disabled={fieldValues.protected && !showModificationProtection}
        className="tw:mb-6"
      />
      <button type="submit" className="tw:hidden">
        Submit
      </button>
    </form>
  );
};

export default InformationGroup;
